<mat-card>
    <mat-card-content>
      <img src="https://menus.linescale.com/assets/images/linescale_logo.png" alt="Linescale logo">
    </mat-card-content>
    <mat-card-header style="padding: 0 24px;">
      <mat-card-title>Sign In</mat-card-title>
      <mat-card-subtitle>to continue</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="padding: 24px;">
      <form (ngSubmit)="login(myLogin)" #myLogin="ngForm">
          <mat-form-field appearance="outline">
              <input matInput type="text" name="username" placeholder="Username" required [(ngModel)]="username">
          </mat-form-field>
          <mat-form-field appearance="outline">
              <input type="password" matInput name="user_password" placeholder="Password" required
                  [(ngModel)]="password">
          </mat-form-field>
          <div *ngIf="loginFailed" class="error-box">
              <h3>Invalid username or password!</h3>
          </div>
          <div class="form-actions">
              <button class="submit-btn" mat-raised-button color="primary" type="submit">Login</button>
          </div>
      </form>
    </mat-card-content>
</mat-card>